import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { orderLawyerInfoSelector } from "../../features/auth/orderLawyerInformationSlice";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import Notes from "../../components/global/Notes/Notes";
import RequiredDocument from "../../components/forms/additionalinformation/RequiredDocument";
import MissingDocsUploadForm from "../../components/forms/orderSummary/MissingDocsUploadForm";
import CancelOrderButton from "../../components/global/CancelOrderButton/CancelOrderButton";
import { useForm } from "react-hook-form";
import useOrderSummary from "../../hooks/useOrderSummary";
import "../ordersSummary/ordersummary.css";
import "../ordersSummary/ordersummary2.css";
import { GetFileSummaryExpress, orderSliceSelector } from "../../features/orders/orderSlice";
import { GetDocStoreDetails, GetEditOrderDetails, orderSummarySelector } from "../../features/ordersSummary/orderSummarySlice";
import moment from "moment";
import { GetAssignedPoliciesByFileID, invoiceSelector } from "../../features/invoice/invoiceSlice";
import Loader from "../orderStatus/Loader";

const PolicyPickup = () => {
  const { postOrderDetailsInfo } = useSelector(orderLawyerInfoSelector);
  const { fileSummaryDetails } = useSelector(orderSliceSelector);
  const { assignedPolicies, loadingInvoice } = useSelector(invoiceSelector);
  const fileloading = useSelector((state) => state.orderLawyerInfo.loading);
  const orderloading = useSelector((state) => state.ordersSlice.loading);
  const documentloading = useSelector((state) => state.uploadDocument.loading)
  const docstoreloading = useSelector((state) => state.orderSummary.loading)
  const { t } = useTranslation();
  const [tab, setTab] = React.useState(1);

  const {
    dispatch,
    register,
    setValue,
    control,
    trigger,
    getValues,
    errors,
    handleChange,
    dropdownChange,
    handleSubmit,
    formSubmit,
    watch,
    reset,
    userLogin,
    propertyArray,
    documentTypeArray,
  } = useOrderSummary();

  const values = getValues();
  const { editOrderDetails, loading, DocStoreDetails } = useSelector(orderSummarySelector);
  const [Clients, setClients] = useState([]);
  // const Clients=[];

  const { id } = useParams();
  const fileID = id - 100000;
  const filenumber = id;

  useEffect(() => {
    dispatch(GetDocStoreDetails(fileID, userLogin?.userId));
    dispatch(GetAssignedPoliciesByFileID(fileID, userLogin?.userId));
  }, [])

  useEffect(() => {
    if (fileSummaryDetails === null) {
      dispatch(GetFileSummaryExpress(fileID, userLogin?.userId));
    }
  }, [fileSummaryDetails]);

  useEffect(() => {
    if (editOrderDetails === null) {
      dispatch(GetEditOrderDetails(fileID, userLogin?.userId));
    }
    else {
      //setClients([]);
      let clientArray = []
      if (editOrderDetails?.propertyList != null && editOrderDetails?.propertyList?.length > 0) {
        editOrderDetails?.propertyList.forEach(element => {
          if (element?.personalBorrowers != null && element?.personalBorrowers?.length > 0) {
            element?.personalBorrowers.forEach(borrower => {
              // setClients([...Clients,(borrower?.firstName +" "+ borrower?.lastName)]);
              clientArray.push((borrower?.firstName + " " + borrower?.lastName));
            });
          }
        });
      }
      setClients(clientArray)
    }
  }, [editOrderDetails]);

  return (
    <div className="bg-[#F5F5ED] flex flex-col px-[190px]">
      <div className="flex flex-row mt-[60px] pt-[32px]">
        <div className="flex flex-flow border-l-box-stroke mr-[50px]">
          <p className="font-normal self-center font-montserrat mr-3">
            {t("Type")}
          </p>
          <h2 className="font-semibold font-open-sans text-[20px]">
            {t(`${postOrderDetailsInfo?.dealType}`)}
          </h2>
        </div>
        <div className="flex flex-flow border-l-box-stroke mr-[50px]">
          <p className="font-normal self-center font-montserrat mr-3">
            {t("StatusM")}
          </p>
          <h2 className="font-semibold font-open-sans text-[20px]">
            {t(`${postOrderDetailsInfo?.fileStatus}`)}
          </h2>
        </div>
        <div className="flex flex-flow border-l-box-stroke mr-[50px]">
          <p className="font-normal self-center font-montserrat mr-3">
            {t("Order")}
          </p>
          <p className="font-semibold font-open-sans text-[20px]">
            {postOrderDetailsInfo?.fileNumber}
          </p>
        </div>
      </div>
      <div className="border-b-[1px] border-black pt-[16px] mb-10"></div>

      <div className="ml-4 w-max gap-[12px] items-center pr-[90px]  mb-10">
        <div>
          <table className="ml-4 gap-[12px] font-semibold items-center pr-[90px] mb-4" style={{ 'width': '150%' }}>
            <tr className="flex bg-white mt-4 border rounded pt-2 pb-2 pr-4 pl-4">
              <td className="w-[388px]">{t("OrderIssuanceDate")}</td>
              <td className="mr-8">:</td>
              <td>{moment(fileSummaryDetails?.submissionDate).format("DD/MM/yyyy")}</td>
            </tr>
            <tr className="flex bg-white mt-4 border rounded pt-2 pb-2 pr-4 pl-4">
              <td className="w-[388px]">{t("YourReferencenumber")}</td>
              <td className="mr-8">:</td>

              <td>{postOrderDetailsInfo?.fileNumber}</td>
            </tr>
            <tr className="flex bg-white mt-4 border rounded pt-2 pb-2 pr-4 pl-4">
              <td className="w-[388px]">{t("Clients")}</td>
              <td className="mr-8">:</td>
              <td>{Clients?.join(',')}</td>
            </tr>
            <tr className="flex bg-white mt-4 border rounded pt-2 pb-2 pr-4 pl-4">
              <td className="w-[388px]">{t("OwnerPolicyNumber")}</td>
              <td className="mr-8">:</td>
              <td>{assignedPolicies?.asignPolicyDetails?.filter(policy => policy?.typeOfPolicy === "Owner")?.map(policy => policy?.policyNumber)?.join(', ') || '-'}</td>
            </tr>
            <tr className="flex bg-white mt-4 border rounded pt-2 pb-2 pr-4 pl-4">
              <td className="w-[388px]">{t("LenderPolicyNumber")}</td>
              <td className="mr-8">:</td>
              <td>{assignedPolicies?.asignPolicyDetails?.filter(policy => ((policy?.typeOfPolicy === "Lender") || policy?.typeOfPolicy === "Loan"))?.map(policy => policy?.policyNumber)?.join(', ') || '-'}</td>
            </tr>
          </table>
        </div>
      </div>
      <div className="flex flex-row">
        {t("DocgeneratedLabel1")}
        <span className="underline text-secondary-red ml-1 mr-1">
          {/* <Link to="/orderstatus?tab=2"> Policy Pickup </Link> */}
          <Link to={`/orderstatus/policypickupdocs/${postOrderDetailsInfo?.fileNumber}?tab=2`}>{t("policyPickuplabel")}</Link>
        </span>
        {t("DocgeneratedLabel2")}
      </div>
      <div className="ml-1 mt-2">
        {DocStoreDetails?.DocStore?.map((item) => {
          return (
            <div className="underline text-secondary-red flex flex-row">
              <Link to={`/orderstatus/policypickupdocs/${postOrderDetailsInfo?.fileNumber}?tab=2`}>{item?.filename}</Link>
            </div>
          );
        })}
      </div>
      <div className="mt-10 mb-10 ">
        <div className="flex flex-row">
          <div className="flex flex-row font-[600] font-open-sans leading-[21.79px]">
            <input
              type="text"
              className="hidden"
              {...register("hdnTab")}
              id="hdnTab"
              placeholder=""
            />
            <a
              onClick={() => {
                setTab(1);
                setValue("hdnTab", "1");
              }}
              href="#"
              className={
                tab === 1
                  ? "bg-[#FAFAFA] px-[24px] py-[14px] relative rounded-t-[3px] tab__selected tab__selected-required-documents"
                  : "bg-[#FAFAFA] px-[24px] py-[14px]"
              }
            >
              {t("DocumentUpload")}
            </a>
            <a
              onClick={() => {
                setTab(2);
                setValue("hdnTab", "2");
              }}
              href="#"
              className={
                tab === 2
                  ? "bg-[#FAFAFA] px-[24px] py-[14px] relative rounded-t-[3px] tab__selected tab__selected-document-upload"
                  : "bg-[#FAFAFA] px-[24px] py-[14px]"
              }
            >
              {t("Notes")}
            </a>
          </div>
        </div>

        {tab === 1 && (
          <div className="bg-white border border-[#A09F9F]">
            <h1 h1 className="font-[700] font-montserrat leading-[26.82px]  pl-[40px] pt-[32px] text-[22px]">
              {t("DocumentUpload")}
            </h1>
            <div className="pb-[32px] px-[40px]">
              <MissingDocsUploadForm
                control={control}
                values={values}
                errors={errors}
                register={register}
                handleChange={handleChange}
                setValue={setValue}
                trigger={trigger}
                dropdownChange={dropdownChange}
                t={t}
                propertyArray={propertyArray}
                documentTypeArray={documentTypeArray}
                reset={reset}
              />
              <div className="break-all pt-[32px]"></div>
            </div>
          </div>
        )}
        {tab === 2 && (<div style={{ marginTop: "-32px" }}><Notes id={id} /></div>)}
      </div >
      {loading || fileloading || orderloading || documentloading || loadingInvoice || docstoreloading ? <Loader /> : ""}
    </div >
  );
};

export default React.memo(PolicyPickup);
